/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum LicenseStatus {
  ACTIVE = "ACTIVE",
  SUSPENDED = "SUSPENDED",
  UNLICENSED = "UNLICENSED",
}

//==============================================================
// END Enums and Input Objects
//==============================================================

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetLicensedProductsQuery
// ====================================================

export interface GetLicensedProductsQuery_confluence_tenantContext_licensedProducts {
  licenseStatus: LicenseStatus;
  productKey: string;
}

export interface GetLicensedProductsQuery_confluence_tenantContext {
  licensedProducts: GetLicensedProductsQuery_confluence_tenantContext_licensedProducts[];
}

export interface GetLicensedProductsQuery {
  confluence_tenantContext: GetLicensedProductsQuery_confluence_tenantContext | null;
}
